import { render, staticRenderFns } from "./LastRefund.vue?vue&type=template&id=3481fa98&scoped=true"
import script from "./LastRefund.vue?vue&type=script&lang=js"
export * from "./LastRefund.vue?vue&type=script&lang=js"
import style0 from "./LastRefund.vue?vue&type=style&index=0&id=3481fa98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3481fa98",
  null
  
)

export default component.exports